import api from "../axios";

export async function validateTenoviCreds(data) {
  const response = await api.post(`/tenovi/check-tenovi-credentials/`, data);
  return response.data;
}
